import { Component, OnInit,ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayService } from 'src/app/gateway.service';
import { Subscription } from 'rxjs/Subscription';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { BusquedaService } from 'src/app/home/busqueda.service';
import { FormGroup, FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-llamadaprogramada',
  templateUrl: './llamadaprogramada.component.html',
  styleUrls: ['./llamadaprogramada.component.scss']
})
export class LlamadaprogramadaComponent implements OnInit {
  private destroy$ = new Subject<void>();

 
  diarioColumns: string[] = ['AGENTE', 'ESTADO','REGISTROS', 'VPH', 'CONTACTABILIDAD', 'CONVERSION', 'EFECTIVIDAD'];

  reporteColumnsRellama: string[] = ['NOMBRE', 'TELEFONO', 'USUARIO', 'AGENTE', 'COMENTARIO', 'FECHA'];
  
  dataSourceRellama = new MatTableDataSource<any>([]);
  dataSource = new MatTableDataSource<any>([]);
  private filtroagente = '';
  public campana={nombre:''};

  @ViewChild('rellamaPaginator') rellamaPaginator: MatPaginator;

  resultsLengthRellama: number = 0;
	pageSize = 5;
  grupoValRellama = new FormGroup({
    fecinicial: new FormControl('', Validators.required),
    fecfinal: new FormControl('', Validators.required),
  });
	private subscription: Subscription;

  constructor(
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    private router: Router,
    private _busqueda: BusquedaService,
    private localsave: LocalSaveService
  ) { }

  ngOnInit() {
  	this.campana = this.localsave.get('supervisorcampana');
   	this.loadrellamadas(0);
    this._busqueda.cleanBusqueda();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
        this.filtroagente = res.filtro;
				this.loadrellamadas(0);
			});
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this._busqueda.cleanBusqueda();
    this.subscription.unsubscribe();
  }

  loadrellamadas(page) {
    this.spinner.show();
    let campana = this.localsave.get('supervisorcampana');
   	let params ={};
    let dateini= new Date();
    let datefin = dateini;

    if(this.grupoValRellama.controls.fecinicial.value === "" || this.grupoValRellama.controls.fecfinal.value===""){
      params = { NUM_PAGINA: page, FILTRO: this.filtroagente, NUM_ELEMENTOS: page, IDCAMPANA: campana.idcampana, FECHAINI:dateini , FECHAFIN:datefin };
    }else{
      params = { NUM_PAGINA: page, FILTRO: this.filtroagente, NUM_ELEMENTOS: page, IDCAMPANA: campana.idcampana, FECHAINI:this.grupoValRellama.controls.fecinicial.value , FECHAFIN:this.grupoValRellama.controls.fecfinal.value };
    }

    this.spinner.show();
    this.gateway.get('rellamadas', params).then((result: any) => {
       //console.log(result)
      let gestiones = result.rows;
      this.dataSourceRellama = new MatTableDataSource(gestiones);
      this.gateway.get('rellamadascount', params).then((result: any) => {
        this.resultsLengthRellama = result.rows[0].total;
        this.spinner.hide();
      });
    }
    ).catch(function (e) {
    });

  }

  public cambioElementosRellama(event?: PageEvent) {
    this.loadrellamadas(event.pageIndex);
  }

  generaRellama(){
    this.rellamaPaginator.firstPage();
    this.loadrellamadas(0);
  }

  back() {
    this.router.navigate(['home/monitorcampana'])
      .then((e) => {
      });
  }

  reload(){
    this.loadrellamadas(0);
  }

  descargaExcel(){

    let datareport = [];
    this.spinner.show();

    let dateini= new Date();
    let datefin = dateini;
    let params = {};
    let campana = this.localsave.get('supervisorcampana');;

    if(this.grupoValRellama.controls.fecinicial.value === "" || this.grupoValRellama.controls.fecfinal.value===""){
      params = { IDCAMPANA: campana.idcampana, FECHAINI:dateini , FECHAFIN:datefin };
    }else{
      params = { IDCAMPANA: campana.idcampana, FECHAINI:this.grupoValRellama.controls.fecinicial.value , FECHAFIN:this.grupoValRellama.controls.fecfinal.value };
    }

    this.gateway.get('excelrellamadas', params).then((result: any) => {
      datareport = result.rows;

      datareport.forEach(function(currentItem) {

        Object.defineProperty(currentItem, 'Cliente',Object.getOwnPropertyDescriptor(currentItem, 'nombre')); 
        delete currentItem['nombre'];
        
        Object.defineProperty(currentItem, 'Telefono',Object.getOwnPropertyDescriptor(currentItem, 'telefono')); 
        delete currentItem['telefono'];   

        Object.defineProperty(currentItem, 'Campaña',Object.getOwnPropertyDescriptor(currentItem, 'campana')); 
        delete currentItem['campana'];   

        Object.defineProperty(currentItem, 'Tipologia',Object.getOwnPropertyDescriptor(currentItem, 'tipologia')); 
        delete currentItem['tipologia'];

        Object.defineProperty(currentItem, 'Comentario',Object.getOwnPropertyDescriptor(currentItem, 'comentario')); 
        delete currentItem['comentario'];

        Object.defineProperty(currentItem, 'Fecha programada',Object.getOwnPropertyDescriptor(currentItem, 'fechallamada')); 
        delete currentItem['fechallamada'];

        Object.defineProperty(currentItem, 'Usuario',Object.getOwnPropertyDescriptor(currentItem, 'usuario')); 
        delete currentItem['usuario'];

        Object.defineProperty(currentItem, 'Nombre agente',Object.getOwnPropertyDescriptor(currentItem, 'nombre_agente')); 
        delete currentItem['nombre_agente'];

        Object.defineProperty(currentItem, 'Apellido agente',Object.getOwnPropertyDescriptor(currentItem, 'apellido')); 
        delete currentItem['apellido'];
      });
      //console.log(datareport)
      const fileName = 'Reporte_llamadas_'+campana.nombre+'_'+ Date.now();
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datareport);
      XLSX.utils.book_append_sheet(wb, ws);

      const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
      this.spinner.hide();
    }
    ).catch(function (e) {
    });

  }

}
